module.exports = __webpack_public_path__ + "static/aloopbuttons-eec0e409206dcc63989013d2ac2e8ae2.png";